// TODO: change name to studiesApi b/c it contains hooks but is not a hook
import useGetApi from "../useGetApi"
import getUrl from "api/apiMap"
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"
import useMutateApi from "../useMutateApi"
import axios from "axios"

const useGetStudy = (id, queryParams) => {
  let query = ""
  if (queryParams) query = "?" + new URLSearchParams(queryParams)?.toString()
  return useGetApi(`${getUrl(apiEndpoints.studies)}${id}/${query ? query : ""}`, queryKeys.studies.detail(Number(id)))
}

const useGetStudyHeader = (id) => {
  return useGetApi(`${getUrl(apiEndpoints.studies)}${id}/header`, queryKeys.studies.header(id))
}

// { body: { study_id } }
const usePostStudy = (id) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(apiEndpoints.studies),
    invalidateQueries: [queryKeys.studies.detail(Number(id))],
  })
}

// TODO: update with new studies api
const useGetStudyActivities = (studyId) => {
  return useGetApi(`${apiEndpoints.studies}${studyId}/activities`, queryKeys.studies.activities(studyId))
}

// { body }
const usePutStudy = () => {
  return useMutateApi({
    method: "put",
    apiEndpoint: getUrl(apiEndpoints.studies),
    invalidateQueries: [queryKeys.studies.all],
    successMsg: "Successfully updated study",
  })
}

const useDeleteStudy = () => {
  return useMutateApi({
    method: "delete",
    apiEndpoint: getUrl(apiEndpoints.studies),
    invalidateQueries: [queryKeys.studies.all],
    successMsg: "Successfully deleted study",
  })
}

/** FAVORITE STUDIES */

const useGetFavoriteStudies = (queryOptions) => {
  return useGetApi(getUrl(apiEndpoints.favoriteStudies), queryKeys.favoriteStudies, queryOptions)
}

const usePostFavoriteStudy = (id) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.studies}`),
    invalidateQueries: [queryKeys.studies.list(), queryKeys.favoriteStudies, queryKeys.studies.detail(id)],
    successMsg: "Successfully updated favorite studies",
  })
}

// TODO: use react-query filter-set hooks instead
const postInterventions = () => {
  let data = axios.post(getUrl(apiEndpoints.filterSet), {
    app_name: "authoring",
    model: "AuthoringStudy",
    field: "study_data",
    jpath: "protocol__general__product_name",
  })
  return data
}

// TODO: use react-query filter-set hooks instead
const postRecruitmentStatus = () => {
  let data = axios.post(getUrl(apiEndpoints.filterSet), {
    app_name: "authoring",
    model: "AuthoringStudy",
    field: "study_data",
    jpath: "protocol__study_timeline__recruitment__recruitment_status",
  })
  return data
}

// TODO: use react-query filter-set hooks instead
const postTherapeuticArea = () => {
  let data = axios.post(getUrl(apiEndpoints.filterSet), {
    app_name: "authoring",
    model: "AuthoringStudy",
    field: "study_data",
    jpath: "protocol__general__therapeutic",
  })
  return data
}

export {
  useDeleteStudy,
  useGetStudy,
  useGetStudyHeader,
  usePostStudy,
  useGetStudyActivities,
  usePutStudy,
  useGetFavoriteStudies,
  usePostFavoriteStudy,
  postInterventions,
  postRecruitmentStatus,
  postTherapeuticArea,
}
